<template>
  <v-container fluid class="ma-0 pa-0">NotFoundComponent</v-container>
</template>

<script>
export default {
  name: "NotFoundComponent",
  components: {},
  data: () => ({}),
  mounted() {},
  methods: {},
};
</script>
